import { ScenarioElementNode } from './ScenarioElementNode'
import { ExternalAppsNode } from './ExternalAppsNode'
import { YourAppNode } from './YourAppNode'

export enum ScenarioDiagramNodeType {
  ScenarioElement = 'ScenarioElement',
  ExternalApps = 'ExternalApps',
  YourApp = 'YourApp',
}

export const SCENARIO_ELEMENT_NODE_TYPES = {
  [ScenarioDiagramNodeType.ScenarioElement]: ScenarioElementNode,
  [ScenarioDiagramNodeType.ExternalApps]: ExternalAppsNode,
  [ScenarioDiagramNodeType.YourApp]: YourAppNode,
}
